module.exports = __webpack_public_path__ + "img/telegram.70dbc3eb.svg";